<template>
  <div
    :class="{ 'has-logo': showLogo }"
    :style="{ backgroundColor: settings.sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground }"
  >
    <logo :collapse="isCollapse" />
    <el-scrollbar :class="settings.sideTheme" wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="settings.sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground"
        :text-color="settings.sideTheme === 'theme-dark' ? variables.menuColor : variables.menuLightColor"
        :unique-opened="true"
        :active-text-color="settings.theme"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="(route, index) in sidebarRouters"
          :key="route.path + index"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/assets/styles/variables.module.scss";

export default {
  components: { Logo, SidebarItem },
  data() {
    return {
      sidebarRouters: [
        {
          name: "Index",
          path: "/index",
          hidden: false,
          component: "Main",
          meta: {
            title: "首页",
            icon: "home",
            noCache: false,
            link: null
          }
        },
        // {
        //     component: "Main",
        //     hidden: false,
        //     meta:
        //         { title: "数据监测", icon: "server", noCache: false, link: "http://ah.zhgylgl.com/owner/position.html?user_id=1" },
        //     name: "Http://ah.zhgylgl.com/owner/position.html?user_id=1",
        //     path: "http://ah.zhgylgl.com/owner/position.html?user_id=1",
        // },
        {
          name: "shipperManager",
          path: "/shipperManager",
          hidden: false,
          redirect: "noRedirect",
          component: "Main",
          // alwaysShow: true,//单个标签也显示item
          meta: {
            title: "货主管理",
            icon: "guide",
            noCache: false,
            link: null
          },
          children: [
            {
              path: "index",
              component: "shipperManager/index",
              name: "shipperManagerIndex",
              meta: { title: "货主管理", icon: "guide", affix: true }
            }
          ]
        },
        // {
        //   name: "release",
        //   path: "/release",
        //   hidden: false,
        //   redirect: "noRedirect",
        //   component: "Main",
        //   // alwaysShow: true,//单个标签也显示item
        //   meta: {
        //     title: "发布运单",
        //     icon: "guide",
        //     noCache: false,
        //     link: null
        //   },
        //   children: [
        //     {
        //       path: "release",
        //       component: "release/release",
        //       name: "release",
        //       meta: { title: "发布运单", icon: "list", affix: true }
        //     }
        //   ]
        // },
        {
          name: "driverCarManager",
          path: "/driverCarManager",
          hidden: false,
          redirect: "noRedirect",
          component: "Main",
          meta: {
            title: "司机车辆管理",
            icon: "manage1",
            noCache: false,
            link: null
          },
          children: [
            {
              path: "driverAuditing",
              component: "driverCarManager/driverAuditing",
              name: "driverAuditing",
              meta: { title: "司机审核", icon: "list", affix: true }
            },
            {
              path: "carAuditing",
              component: "driverCarManager/carAuditing",
              name: "carAuditing",
              meta: { title: "车辆审核", icon: "dashboard", affix: true }
            }
          ]
        },
        {
          name: "waybillManagement",
          path: "/waybillManagement",
          hidden: false,
          redirect: "noRedirect",
          component: "Main",
          meta: {
            title: "运单管理",
            icon: "manage",
            noCache: false,
            link: null
          },
          children: [
            {
              path: "allList",
              component: "waybillManagement/allList",
              name: "allList",
              meta: { title: "总运单", icon: "allWaybill", affix: true }
            },
            {
              path: "inList",
              component: "waybillManagement/inList",
              name: "inList",
              meta: { title: "进行中列表", icon: "documentation", affix: true }
            },
            {
              path: "finished",
              component: "waybillManagement/finished",
              name: "finished",
              meta: { title: "已完成列表", icon: "documentation", affix: true }
            },
            {
              path: "suspendList",
              component: "waybillManagement/suspendList",
              name: "suspendList",
              meta: {
                title: "已暂停运单",
                icon: "24gf-pauseSquare",
                affix: true
              }
            },
            {
              path: "trackList",
              component: "waybillManagement/trackList",
              name: "trackList",
              meta: { title: "分运单追踪", icon: "clipboard", affix: true }
            }
          ]
        },
        {
          name: "moneyManagment",
          path: "/moneyManagment",
          hidden: false,
          redirect: "noRedirect",
          component: "Main",
          meta: {
            title: "财务管理",
            icon: "waybill",
            noCache: false,
            link: null
          },
          children: [
            {
              path: "auditing",
              component: "moneyManagment/auditing",
              name: "auditing",
              meta: { title: "财务审核", icon: "pay", affix: true }
            },
            {
              path: "collect",
              component: "moneyManagment/collect",
              name: "collect",
              meta: {
                title: "汇总代开",
                icon: "operation_all_list",
                affix: true
              }
            },
            {
              path: "shipperStream",
              component: "moneyManagment/shipperStream/shipperStream",
              name: "shipperStream",
              meta: { title: "货主流水", icon: "goods_user", affix: true }
            },
            {
              path: "driverStream",
              component: "moneyManagment/driverStream",
              name: "driverStream",
              meta: {
                title: "司机收款信息",
                icon: "driver_management",
                affix: true
              }
            },
            {
              path: "vaildate",
              component: "moneyManagment/payValidate/payValidate",
              name: "vaildate",
              meta: { title: "支付结果验证", icon: "validate", affix: true }
            },
            {
              path: "invoiceManage",
              component: "moneyManagement/invoiceManage",
              meta: {
                title: "发票管理",
                icon: "waybill",
                noCache: false,
                link: null
              }
            },
            {
              path: "invoiceDetail",
              component: "moneyManagement/invoiceDetail",
              meta: {
                title: "发票明细",
                icon: "waybill",
                noCache: false,
                link: null
              }
            }
          ]
        },
        {
          name: "set",
          path: "/set",
          hidden: false,
          component: "Main",
          redirect: "noRedirect",
          alwaysShow: true, //单个标签也显示item
          meta: {
            title: "设置",
            icon: "system",
            noCache: false,
            link: null
          },
          children: [
            {
              path: "feedback",
              component:"FeedBack/feedback",
              name: "feedback",
              meta: { title: "反馈记录", icon: "allWaybill", affix: false }
            },
            {
              path: 'evaluate',
              component: 'Evaluate/evaluate',
              name: 'evaluate',
              meta: { title: '评价记录', icon: 'documentation', affix: false }
            },
            {
              path: 'dataManage',
              component: 'DataManage/dataManage',
              name: 'dataManage',
              meta: { title: '数据调取', icon: '24gf-pauseSquare', affix: false }
            },
          ]
        }
        // {
        //     "name": "withdraw",
        //     "path": "/withdraw",
        //     "hidden": false,
        //     "component": "Main",
        //     "redirect": "noRedirect",
        //     alwaysShow: true,
        //     "meta": {
        //         "title": "提现管理",
        //         "icon": "tixian",
        //         "noCache": false,
        //         "link": null
        //     },
        //     "children": [
        //         {
        //             path: 'allList',
        //             component: "withdraw/allList",
        //             name: 'allList',
        //             meta: { title: '全平台提现列表', icon: 'infoAuth', affix: true }
        //         }]
        // },
      ]
    };
  },
  mounted() {
    // console.log(this.settings.sideTheme, variables, variables.menuLightBackground);
  },
  watch: {
    sidebar: {
      handler(newV, oldV) {
        console.log(newV);
      },
      deep: true
    }
  },
  computed: {
    ...mapState(["settings"]),
    ...mapGetters(["sidebar"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // 如果设置了路径，侧边栏将突出显示您设置的路径
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};
</script>


<style lang="scss" scoped>
::v-deep .el-scrollbar ::-webkit-scrollbar {
  width: 0 !important;
}
</style>
